import { Box } from '@material-ui/core';
import * as React from 'react';
import { StandardAlert } from '.';

export default function EmptyAnswer({ title, userName }) {
    const body = `${userName} has not specified ${title} yet.`;
    return (
        <Box style={{ height: '100%', padding: '30px 24px 0' }}>
            <StandardAlert height={`90%`} title={`No ${title}`} body={body} />
        </Box>
    );
}
